export const [SIGN_IN_USER_START, SIGN_IN_USER_SUCCESS, SIGN_IN_USER_FAILED, SIGN_OUT_USER, UPDATE_CLIENT, UPDATE_EMAIL,
    UPDATE_PASSWORD,
    SET_BASE_URL, SET_DESTINATION_URL, SET_CLIENT_APP_VERSION, SET_NEW_CLIENT_APP_VERSION, SET_EQUIPMENT_INTERVAL, SET_EQUIPMENT_TIMEOUT, UPDATE_ROLES,
    ADD_INTERVALS, ADD_TIMEOUTS, CLEAR_INTERVALS_AND_TIMEOUTS
] = [
    'SIGN_IN_USER_START', 'SIGN_IN_USER_SUCCESS', 'SIGN_IN_USER_FAILED', 'SIGN_OUT_USER', 'UPDATE_CLIENT', 'UPDATE_EMAIL', 'UPDATE_PASSWORD'
    , 'SET_BASE_URL', 'SET_DESTINATION_URL', 'SET_CLIENT_APP_VERSION', 'SET_NEW_CLIENT_APP_VERSION', 'SET_EQUIPMENT_INTERVAL', 'SET_EQUIPMENT_TIMEOUT', 'UPDATE_ROLES',
    'ADD_INTERVALS', 'ADD_TIMEOUTS', 'CLEAR_INTERVALS_AND_TIMEOUTS'
];

export const TOGGLE_SCHEDULER_VIEW = 'TOGGLE_SCHEDULER_VIEW';